import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";

import IncidentEvidence from "./IncidentEvidence";
import EvidencePreview from "./EvidencePreview";
import { evidenceTypes, evidenceTypesObj } from "./CONSTANTS";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import { AiFillFileExcel, AiOutlineFile, AiOutlineFileJpg, AiOutlineFilePdf, AiOutlineFileWord } from "react-icons/ai";
import FormInput from "app/Components/_form/FormInput/FormInput";

const IncidentEvidences = ({ dataArray = [], errorArray = [], onChange = () => { }, onChangeFile = () => { }, onAdd = () => { }, onDelete = () => { }, viewOnly, isDocuments, isDocumentObj }) => (
  <div className="table-responsive drillingPlan-plannedEdit">
    <table id="user_table" className="table table-bordered mb-3">
      <thead>
        <tr>
          <th scope="col">Category</th>
          <th scope="col">{viewOnly ? "Description" : "Description/Upload File"}</th>
          <th scope="col">File View</th>
          {!viewOnly && <th scope="col">Remove</th>}
        </tr>
      </thead>
      <tbody>
        {dataArray.length > 0 ? (
          dataArray.map((x, index) => {
            return x.deleted ? null : (
              <tr key={index}>
                <th>
                  {viewOnly ? (
                    <span>{isDocuments ? x.type : isDocumentObj ? evidenceTypesObj[x.type] : evidenceTypes[x.type]}</span>
                  ) : isDocuments ? (
                    // <select
                    //     value={x.type}
                    //     name="type"
                    //     onChange={({ target: { name, value } }) => onChange({ name, value, index })}
                    //     className="form-control"
                    //     disabled={!!x.fileId}
                    // >
                    //     {Object.keys(evidenceTypes).map((key) => (
                    //         <option key={key} value={key}>
                    //             {evidenceTypes[key]}
                    //         </option>
                    //     ))}
                    // </select>
                    <FormInput
                      className="form-control"
                      name="type"
                      value={x.type}
                      onChange={({ target: { name, value } }) => onChange({ name, value, index })}
                      id="id"
                      disabled
                    ></FormInput>
                  ) : (

                    <SimpleSelect
                      value={x.type}
                      name="type"
                      onChange={({ target: { name, value } }) => onChange({ name, value, index })}
                      className="form-control"
                      disabled={!!x.fileId}
                      options={Object.keys(isDocumentObj ? evidenceTypesObj : evidenceTypes)}
                      object={isDocumentObj ? evidenceTypesObj : evidenceTypes}
                      init="none"
                    ></SimpleSelect>
                  )}
                </th>
                <td>
                  {viewOnly ? (
                    <span>{x.description}</span>
                  ) : (
                    <IncidentEvidence
                      onChangeFile={({ file }, responseData) => {
                        onChangeFile({ file, responseData, index });
                      }}
                      onChangeDescription={(value) => onChange({ index, name: "description", value })}
                      description={x.description}
                      fileId={x.fileId}
                      extensions={
                        evidenceTypes[x.type] === evidenceTypes.photo
                          ? ["jpg", "jpeg", "png"]
                          : evidenceTypes[x.type] === evidenceTypes.video
                            ? ["mp4"]
                            : x.type === 'Document' || x.type === 'document' ? ["doc", "docx", "html", "pdf", "txt", "csv", "xls", "xlsx"]
                              : []
                      }
                    />
                  )}
                  <span className="small text-danger">{errorArray[index]?.description || errorArray[index]?.fileId}</span>
                </td>
                <td style={{ width: "35%" }}>{x.file && <EvidencePreview file={x.file} type={x.type} />}</td>
                {!viewOnly && (
                  <td>
                    <div className="actionIconsGroup">
                      <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}>
                        <span onClick={() => onDelete(index)} className="pointer icons text-danger font-20">
                          <FiMinusCircle />
                        </span>
                      </OverlayTrigger>
                    </div>
                  </td>
                )}
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="10" align="center">
              {/* <div className="alert alert-danger d-inline-block m-0">
                                <strong>No Evidence</strong>
                            </div> */}
            </td>
          </tr>
        )}
        {!viewOnly && (
          <tr>
            <td colSpan="10">
              <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add Row</Tooltip>}>
                <Button className="addRowPluseIcon" onClick={onAdd}>
                  <FiPlusCircle />
                </Button>
              </OverlayTrigger>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default IncidentEvidences;
